import { useMutation } from "@tanstack/react-query";
import { getSubscriptionFlowApiClient } from "@shared/apis/sidekick/api-factories";
import { toast } from "@shared/services/toast";
import { appEventEmitter } from "@shared/events/app-event-emitter";
import { appLogger } from "@shared/services/app-logger";
import { apiResponseErrorHandler } from "@shared/apis/sidekick/api-error-handler";

type Props = {
  onSuccess?: () => void;
};

type Params = {
  subscriptionId: string;
  address: {
    line1: string;
    line2: string | null;
    state: string;
    city: string;
    zipCode: string;
    country: string;
  };
};

export const useSubscriptionFlowConfirmation = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getSubscriptionFlowApiClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const response = await api.subscriptionFlowControllerConfirmSubscription({
        id: params.subscriptionId,
        confirmSubscriptionPaymentRequestOmitted: {
          address: params.address,
        },
      });
      onSuccess?.();
      return response;
    },
    onError: async (error: Error) => {
      appEventEmitter.emit({
        eventType: "sidekick-registration-complete-failure",
      });
      const apiError = await apiResponseErrorHandler(error);
      appLogger.error(`Failed to confirm subscription`, { error, apiError });
      toast.error(
        "Failed to confirm your subscription. Please check if all information is correct and try again, or contact support if the issue persists."
      );
    },
  });

  return mutation;
};
